define('content',[
  "globals",
  "models/content",
  "views/content/content",
  "views/content/filter",
  "views/content/login",
  "views/content/topic-navigation"
], function (globals, ContentModel, ContentView, ContentFilterView, LoginView, TopicNavigationView) {
  "use strict";

  $(function () {
    var library = $("main").data("library"),
        version = $("main").data("version"),
       language = $("main").data("language"),
           path = $("main").data("path");

    if ($("h1").length) document.title = $("h1").text();

    globals.content = new ContentModel();

    if (!_.isEmpty(library) && !_.isEmpty(path)) {
      globals.content.set("location", {
        library: library,
        version: version,
        language: language,
        path: path
      });
    }

    new LoginView({ el: $(".navbar #login") });

    new ContentView({
      model: globals.content,
      el: $("main")
    });

    new TopicNavigationView({
      model: globals.content,
      el: $(".topic-navigation")
    });

    new ContentFilterView({ el: $("#content-filter") });
  });
});

